module.exports = __webpack_public_path__ + "media/ai_video_oil_painting.a8c66ea5.mp4";